import { FC } from 'react'
import styles from './ImageCTA.module.scss'
import { ImageCTAProps } from './types'
import { Img } from 'components/basic/Img'
import { Button } from 'components/Phantom/Button'

export const ImageCTA: FC<ImageCTAProps> = (props) => {
	const {
		id = 'clinically-validated',
		eyebrow = 'Clinically Validated',
		headline = 'Autopilot gives you up to one more hour of sleep every night',
		cta,
		img = {
			src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/2024-phantom-launch/hiw-image-cta-desktop.jpg',
			alt: 'A woman laying on the Pod',
		},
		sources = [
			{
				src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/2024-phantom-launch/hiw-image-cta-mobile.png',
				mediaQuery: '(max-width: 599px)',
			},
			{
				src: 'https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/2024-phantom-launch/hiw-image-cta-desktop.jpg',
				mediaQuery: '(min-width: 600px)',
			},
		],
	} = props
	return (
		<section
			className={styles.container}
			id={id}
		>
			<header className={styles.header}>
				<p>{eyebrow}</p>
				<h2>
					{headline}&nbsp;<sup>*</sup>
				</h2>
				{cta && cta.text && cta.href && (
					<Button.Primary
						id={`${id}-cta`}
						href={cta.href}
						className={styles.cta}
					>
						{cta.text}
					</Button.Primary>
				)}
			</header>
			<Img
				{...img}
				sources={sources}
				className={styles.image}
				objectFit={'cover'}
				dprHeight={1400}
			/>
		</section>
	)
}
